import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { BulkDeviceSignalTagDocument } from './bulk.generated';

export const useBulkDeviceSignalTag = (
  options: ApiOptions<typeof BulkDeviceSignalTagDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(BulkDeviceSignalTagDocument, {
    ...useNotifications(BulkDeviceSignalTagDocument, {
      failure: t('api.device_signal_tags.bulk_add_error'),
      success: (data) => {
        const count = data.bulkTag?.taggables.length ?? 0;
        return t('api.device_signal_tags.bulk_add_success_plural', { count });
      },
    }),
    ...options,
  });
};
